import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { analyseFiles, analyseProfileRequirements } from '../redux/analysisSlice';
import type { AppDispatch } from '../redux';
import { resetAnalysis } from '../redux/analysisSlice';

interface ProcessingContext {
  title: string;
  description: string;
}

export const useProcessingHandler = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingContext, setProcessingContext] = useState<ProcessingContext | null>(null);

    const startProcessing = async (files: File[], context: ProcessingContext, userPrompt?: string) => {
        dispatch(resetAnalysis()); 
        setProcessingContext(context);
        setIsProcessing(true);
  
        try {
            await dispatch(
                analyseFiles({ files, userPrompt: userPrompt || '' })
            ).unwrap();  
            setIsProcessing(false);
        } catch (error) {
            console.error('Error during processing:', error);
            setIsProcessing(false);
        }
    };

    const startReprocessing = async (context: ProcessingContext, taskId: string, userPrompt?: string) => {
        setProcessingContext(context);
        setIsProcessing(true);
  
        try {
            if (userPrompt) {
                console.log(userPrompt)
                await dispatch(
                    analyseProfileRequirements({taskId, userPrompt})
                ).unwrap();  
                setIsProcessing(false);
            }
        } catch (error) {
            console.error('Error during processing:', error);
            setIsProcessing(false);
        }
    };
  
    return {
        isProcessing,
        processingContext,
        startProcessing,
        startReprocessing
    };
};
  
